var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainContent"},[_c('QA',{attrs:{"loading":_vm.loading,"qidList":_vm.qidList,"isEnd":_vm.isEnd,"selectedQidSmall":_vm.selectedQidSmall},on:{"update:loading":function($event){_vm.loading=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }